export default {
    "facet": {
        "showFacetTextView": "Afficher le texte",
        "showFacetChartView": "Afficher le graphique",
        "itemExclude": "Exclure",
        "applyFilters": "{selections, plural, one {Appliquer le filtre} other {Appliquer les filtres}}",
        "clearFilters": "{selected, plural, one {Effacer le filtre} other {Effacer les filtres}}",
        "loadMore": "Charger plus",
        "showMore": "Afficher plus",
        "showLess": "Afficher moins",
        "displayed": "Affiché",
        "removeAll": "Supprimer tout",
        "searchPlaceholder": "Rechercher...",
        "itemSelect": "Sélectionner cette valeur",
        "itemUnselect": "Désélectionner cette valeur",
        "filterItem": "Garder les documents qui contiennent {terme}",
        "filterItems" : "Garder les documents qui contiennent n'importe lequel de ces termes",
        "filterItemsAnd": "Garder les documents qui contiennent tous ces termes",
        "excludeItems" : "Exclure les documents contenant un de ces termes",
        "clearSelects" : "Enlever les filtres",
        "searchItems" : "Rechercher une valeur dans cette liste",
        "searchNoResult": "Pas de résultat",
        "openItem": "Ouvrir",
        "closeItem": "Refermer",
        "authors": {
            "title": "Auteurs"
        },
        "concepts": {
            "title": "Concepts"
        },
        "company": {
            "title": "Sociétés"
        },
        "docformat": {
            "title": "Formats"
        },
        "doctype": {
            "title": "Types de document"
        },
        "documentlanguages": {
            "title": "Langues"
        },
        "fileext": {
            "title": "Extensions de fichiers"
        },
        "filename": {
            "title": "Noms de fichiers"
        },
        "geo": {
            "title": "Lieux"
        },
        "matchingpartnames": {
            "title": "Partnames"
        },
        "modified": {
            "title": "Dates"
        },
        "person": {
            "title": "Personnes"
        },
        "refine": {
            "title": "Affiner la recherche",
            "input": {
                "label": "Affiner",
                "buttonTitle": "Affiner",
                "placeholder": "Affiner par ..."
            }
        },
        "size": {
            "title": "Tailles"
        },
        "tagcloud": {
            "title": "Nuage de mots"
        },
        "title": {
            "title": "Titres"
        },
        "treepath": {
            "title": "Sources"
        },
        "recentQueries": {
            "title": "Requêtes récentes"
        },
        "recentQueriesPublic": {
            "title": "Requêtes publiques récentes"
        },
        "mySearch": {
            "title": "Ma recherche",
            "itemRemove": "Supprimer"
        },
        "search": {
            "label": "Rechercher",
            "buttonTitle": "Rechercher",
            "placeholder": "Rechercher ...",
            "showSearchForm": "Afficher le formulaire de recherche",
            "hideSearchForm": "Masquer le formulaire de recherche"
        },
        "range": {
            "year": "{date, date, sqYear}",
            "monthYear": "{date, date, sqMonthYear}",
            "weekYear": "s{week, number, sqWeek} {weekYear, number, sqYear}",
            "apply": "Appliquer",
            "clear": "Effacer",
            "unavailable": "Aucune plage disponible"
        },

        "filters":{
            "add":"Ajouter la facette",
            "addAll": "Ajouter toutes les facettes",
            "remove":"Retirer la facette",
            "removeAll": "Retirer toutes les facettes",
            "setDefaults": "Facettes par défaut",
            "clear":"Réinitialiser",
            "moreFilters":"",
            "showFilters":"Montrer les filtres",
            "hideFilters":"Cacher les filtres",

            "back": "Retour aux filtres",
            "selectedFilters": "Ce filtre est utilisé dans la recherche actuelle",

            "customizeFacets": "Sélectionnez les facettes à montrer ou cacher"
        },

        "selectedValue": "Cette valeur est sélectionnée dans la recherche actuelle",
        "previous": "Précédent",
        "next": "Suivant",
        "filterItemCountTooltip": "{count} valeurs possibles pour ce filtre",
    },

    "facetCard": {
        "expand": "Déplier",
        "collapse": "Replier",
        "enlarge": "Agrandir",
        "reduce": "Réduire",
        "openSettings": "Ouvrir les paramètres",
        "saveSettings": "Enregistrer les paramètres"
    }
};
